import React, { useContext, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { QuantityContext } from '../../QuantitySelector/QuantityProvider';
import { formatCurrency } from '../../../utilities/financing';
import stateFees from './prices.json';

const getStateFee = (state, tireQuantity) => {
  const price = stateFees[state] ?? 0;
  if (state === 'NC') {
    return 'See Store';
  }
  return formatCurrency(price * tireQuantity);
};

const getEnvironmentalDisposalPrice = (tireQuantity) => (
  formatCurrency(stateFees.disposal * tireQuantity)
);

const StateFees = ({ statePostal, isSplitFitment }) => {
  const { quantities } = useContext(QuantityContext);
  const [totalQuantity, setTotalQuantity] = useState(0);

  useEffect(() => {
    const { qtyFront, qtyRear } = quantities;

    if (isSplitFitment) {
      setTotalQuantity(
        qtyFront + qtyRear,
      );
    } else {
      setTotalQuantity(
        qtyFront,
      );
    }
  }, [quantities, isSplitFitment]);

  return (
    <>
      <tr>
        <th scope="row">
          Required State Tire Fee (
          {statePostal}
          )
        </th>
        <td>
          {getStateFee(statePostal, totalQuantity)}
        </td>
      </tr>
      <tr>
        <th scope="row">
          Environmentally Responsible Tire Disposal Fee
        </th>
        <td>
          {getEnvironmentalDisposalPrice(totalQuantity)}
        </td>
      </tr>
    </>
  );
};

StateFees.propTypes = {
  statePostal: propTypes.string,
  isSplitFitment: propTypes.bool,
};

export { StateFees };
